/* How to install eSIM — calm swipe guide. No dependencies. */
(function () {
  'use strict';

  function $(root, sel) { return root.querySelector(sel); }
  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function readJSON(root, sel) {
    var el = $(root, sel);
    if (!el) return {};
    try { return JSON.parse(el.textContent); } catch (e) { return {}; }
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  /* "**bold**" → <b>bold</b>; newlines kept by CSS (white-space: pre-line) */
  function rich(s) {
    return String(s || '').split('**').map(function (part, i) {
      return i % 2 ? '<b>' + esc(part) + '</b>' : esc(part);
    }).join('');
  }

  /* ---------- Device detection ---------- */
  function brandFromModel(model) {
    if (!model) return null;
    if (/^SM-|Samsung|Galaxy/i.test(model)) return 'samsung';
    if (/Pixel/i.test(model)) return 'pixel';
    return 'other';
  }
  function detect(cb) {
    var q = (location.search.match(/[?&]device=([a-z]+)/i) || [])[1];
    if (q) {
      q = q.toLowerCase();
      if (q === 'iphone' || q === 'apple' || q === 'ios') return cb({ phone: 'iphone' });
      /* ?device= also previews brands that aren't released yet */
      if (q === 'samsung' || q === 'pixel' || q === 'other') return cb({ phone: 'android', brand: q, known: true, preview: true });
      if (q === 'android') return cb({ phone: 'android', brand: 'samsung', known: false, preview: true });
    }
    var ua = navigator.userAgent || '';
    var uad = navigator.userAgentData;
    var isAndroid = /Android/i.test(ua) || (uad && /Android/i.test(uad.platform || ''));
    if (!isAndroid) return cb({ phone: 'iphone' });

    var m = ua.match(/Android[^;)]*;\s*([^;)]+?)\s*(?:Build|[;)])/i);
    var uaModel = m && m[1] && !/^K$/i.test(m[1]) ? m[1] : '';
    var b = brandFromModel(uaModel);
    if (b) return cb({ phone: 'android', brand: b, known: true });

    if (uad && uad.getHighEntropyValues) {
      uad.getHighEntropyValues(['model']).then(function (v) {
        var bb = brandFromModel(v && v.model);
        cb(bb ? { phone: 'android', brand: bb, known: true } : { phone: 'android', brand: 'samsung', known: false });
      }, function () { cb({ phone: 'android', brand: 'samsung', known: false }); });
      return;
    }
    cb({ phone: 'android', brand: 'samsung', known: false });
  }

  /* ---------- One guide ---------- */
  function Guide(root) {
    this.root = root;
    this.media = readJSON(root, '[data-hti-media]');
    this.t = readJSON(root, '[data-hti-copy]');
    if (!this.t.iphone) return;
    this.el = {
      apple: $(root, '[data-hti-apple]'),
      android: $(root, '[data-hti-android]'),
      androidLabel: $(root, '[data-hti-android-label]'),
      menu: $(root, '[data-hti-menu]'),
      stepText: $(root, '[data-hti-steptext]'),
      stage: $(root, '[data-hti-stage]'),
      trail: $(root, '[data-hti-trail]'),
      car: $(root, '[data-hti-car]'),
      swipe: $(root, '[data-hti-swipe]'),
      tabs: $(root, '[data-hti-tabs]'),
      text: $(root, '[data-hti-text]'),
      tip: $(root, '[data-hti-tip]'),
      tipText: $(root, '[data-hti-tip-text]'),
      airplane: $(root, '[data-hti-airplane]'),
      del: $(root, '[data-hti-del]'),
      prev: $(root, '[data-hti-prev]'),
      next: $(root, '[data-hti-next]'),
      lb: $(root, '[data-hti-lb]'),
      lbMedia: $(root, '[data-hti-lb-media]'),
      lbReplay: $(root, '[data-hti-lb-replay]')
    };
    /* Android brands released in the theme editor (empty = Apple only) */
    this.brands = (root.getAttribute('data-hti-brands') || '').split(',').filter(Boolean);
    this.state = { phone: 'iphone', brand: this.brands[0] || 'samsung', brandKnown: false, opt: 'tap', cur: 0 };
    this.lockUntil = 0;
    this.bind();
    var self = this;
    this.build();
    detect(function (d) {
      var B = self.brands;
      if (d.phone === 'android' && !d.preview) {
        if (!B.length) return; /* Android not released yet → stay on Apple */
        if (B.indexOf(d.brand) === -1) { d.brand = B[0]; d.known = false; }
      }
      self.state.phone = d.phone;
      if (d.brand) self.state.brand = d.brand;
      self.state.brandKnown = !!d.known && B.length > 1;
      self.build();
    });
  }

  Guide.prototype.steps = function () {
    var s = this.state, t = this.t, M = this.media;
    var isI = s.phone === 'iphone';
    /* Samsung has its own guide (tap to install only); Pixel / Other use the generic placeholder steps */
    var own = !isI && t.android[s.brand] && t.android[s.brand].steps ? t.android[s.brand] : null;
    var c = isI ? t.iphone : (own || t.android);
    var p = (isI || own) ? {} : (t.android.paths[s.brand] || t.android.paths.samsung);
    function fill(x) {
      return String(x).replace('{add}', p.add || '').replace('{list}', p.list || '').replace('{roam}', p.roam || '');
    }
    var o = c.opts.filter(function (x) { return x.key === s.opt; })[0] || c.opts[0];
    var pre, first;
    if (isI) {
      pre = 'iphone_';
      first = { img: M['iphone_' + o.key + '_poster'] || '', vid: M['iphone_' + o.key + '_video'] || '' };
    } else if (own) {
      pre = s.brand + '_';
      first = { img: M[pre + 's1'] || '', vid: M[pre + 's1_video'] || '' };
    } else {
      pre = 'android_';
      first = { img: M['android_' + o.key + '_img'] || '', vid: '' };
    }
    var list = [{ g: 0, t: fill(o.t), img: first.img, vid: first.vid, tabs: c.opts.length > 1 }];
    var grp = [1, 1, 1, 2, 2];
    c.steps.forEach(function (x, i) {
      var n = i + 2;
      list.push({ g: grp[i], t: fill(x), img: M[pre + 's' + n] || '', vid: M[pre + 's' + n + '_video'] || '', tip: i === c.steps.length - 1 });
    });
    this.air = M[pre + 'air'] || '';
    this.tipText = c.tip || t.tip;
    this.opt = o;
    this.opts = c.opts;
    return list;
  };

  Guide.prototype.build = function () {
    var self = this, t = this.t, el = this.el, s = this.state;
    this.list = this.steps();
    var n = this.list.length;
    s.cur = Math.max(0, Math.min(n - 1, s.cur));

    /* device picker */
    var isI = s.phone === 'iphone';
    el.apple.classList.toggle('is-on', isI);
    el.apple.setAttribute('aria-pressed', isI ? 'true' : 'false');
    el.android.classList.toggle('is-on', !isI);
    if (this.brands.length <= 1) el.android.setAttribute('aria-pressed', isI ? 'false' : 'true');
    el.androidLabel.textContent = (!isI && s.brandKnown) ? (t.android.brandLabels[s.brand] || 'Android') : 'Android';
    $$(el.menu, '[data-hti-brand]').forEach(function (b) {
      b.setAttribute('aria-selected', (!isI && s.brandKnown && b.getAttribute('data-hti-brand') === s.brand) ? 'true' : 'false');
    });

    /* slides */
    el.car.innerHTML = this.list.map(function (st, i) {
      var inner;
      if (st.img) inner = '<img src="' + esc(st.img) + '" alt="" loading="' + (i < 2 ? 'eager' : 'lazy') + '" decoding="async">';
      else if (st.vid) inner = '<video src="' + esc(st.vid) + '#t=0.1" muted playsinline preload="metadata" aria-hidden="true" style="width:100%;height:100%;object-fit:cover;object-position:top;display:block"></video>';
      else inner = '<span class="hti-sl__ph">' + esc(t.soon) + '</span>';
      if (st.vid) inner += '<span class="hti-play" aria-hidden="true"><svg width="30" height="30" viewBox="0 0 24 24" fill="#fff"><path d="M8 5.5v13l11-6.5z"/></svg></span>';
      var label = (st.vid ? t.play : t.zoom) + ' · ' + t.step.replace('{n}', i + 1).replace('{t}', n);
      return '<div class="hti-sl" data-i="' + i + '"><button type="button" class="hti-sl__img" aria-label="' + esc(label) + '">' + inner + '</button></div>';
    }).join('');

    /* trail */
    el.trail.innerHTML = t.groups.map(function (label, gi) {
      var idx = [];
      self.list.forEach(function (st, i) { if (st.g === gi) idx.push(i); });
      return '<div class="hti-trail__grp" style="flex:' + idx.length + '">' +
        '<div class="hti-trail__segs">' + idx.map(function (i) {
          return '<button type="button" class="hti-segbar" data-go="' + i + '" aria-label="' + esc(t.goTo.replace('{n}', i + 1)) + '"></button>';
        }).join('') + '</div>' +
        '<button type="button" class="hti-trail__lbl" data-go="' + idx[0] + '" data-g="' + gi + '">' + esc(label) + '</button></div>';
    }).join('');

    /* method tabs */
    el.tabs.setAttribute('aria-label', t.methodLabel);
    el.tabs.innerHTML = this.opts.map(function (o) {
      return '<button type="button" role="tab" data-opt="' + esc(o.key) + '" aria-selected="' + (o.key === self.opt.key ? 'true' : 'false') + '">' + esc(o.label) + '</button>';
    }).join('');

    el.tipText.innerHTML = rich(this.tipText);
    el.del.innerHTML = rich(t.del);
    el.airplane.hidden = !this.air;

    /* a screenshot that isn't uploaded yet → "coming soon" instead of a broken image */
    $$(el.car, '.hti-sl__img img').forEach(function (im) {
      im.addEventListener('error', function () {
        var i = +im.closest('.hti-sl').getAttribute('data-i');
        if (self.list[i]) self.list[i].img = '';
        var ph = document.createElement('span');
        ph.className = 'hti-sl__ph';
        ph.textContent = t.soon;
        im.parentNode.replaceChild(ph, im);
      });
    });
    this.paint();
    this.jump(s.cur, false);
  };

  /* update everything that depends on the current step */
  Guide.prototype.paint = function () {
    var el = this.el, t = this.t, cur = this.state.cur, n = this.list.length, st = this.list[cur];
    el.stepText.textContent = t.step.replace('{n}', cur + 1).replace('{t}', n);
    el.stage.textContent = t.stages[st.g] || '';
    $$(el.car, '.hti-sl').forEach(function (sl, i) {
      sl.classList.toggle('is-on', i === cur);
      var b = sl.firstChild;
      if (i === cur) b.removeAttribute('tabindex'); else b.setAttribute('tabindex', '-1');
    });
    $$(el.trail, '.hti-segbar').forEach(function (b) {
      var i = +b.getAttribute('data-go');
      b.classList.toggle('is-done', i < cur);
      b.classList.toggle('is-now', i === cur);
      if (i === cur) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current');
    });
    $$(el.trail, '.hti-trail__lbl').forEach(function (b) {
      b.classList.toggle('is-on', +b.getAttribute('data-g') === st.g);
    });
    el.tabs.hidden = !st.tabs;
    el.text.innerHTML = rich(st.t);
    el.tip.hidden = !st.tip;
    el.swipe.classList.toggle('is-hidden', cur !== 0);
    el.prev.disabled = cur === 0;
    el.next.disabled = cur === n - 1;
  };

  Guide.prototype.slideW = function () {
    var first = this.el.car.firstElementChild;
    return first ? first.offsetWidth + 24 : 304;
  };

  Guide.prototype.jump = function (i, smooth) {
    var car = this.el.car;
    var left = i * this.slideW();
    this.lockUntil = smooth ? Date.now() + 700 : 0;
    if (car.scrollTo) {
      try { car.scrollTo({ left: left, behavior: smooth ? 'smooth' : 'auto' }); return; } catch (e) {}
    }
    car.scrollLeft = left;
  };

  Guide.prototype.goTo = function (i) {
    i = Math.max(0, Math.min(this.list.length - 1, i));
    this.state.cur = i;
    this.paint();
    this.jump(i, true);
  };

  Guide.prototype.bind = function () {
    var self = this, el = this.el;

    /* swipe sync */
    var raf = 0;
    el.car.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        if (Date.now() < self.lockUntil) return;
        var i = Math.round(el.car.scrollLeft / self.slideW());
        i = Math.max(0, Math.min(self.list.length - 1, i));
        if (i !== self.state.cur) { self.state.cur = i; self.paint(); }
      });
    }, { passive: true });

    /* slide tap: other slide → go there; current → full screen */
    el.car.addEventListener('click', function (e) {
      var sl = e.target.closest('.hti-sl');
      if (!sl) return;
      var i = +sl.getAttribute('data-i');
      if (i !== self.state.cur) { self.goTo(i); return; }
      var st = self.list[i];
      if (st.vid) self.open({ vid: st.vid, poster: st.img });
      else if (st.img) self.open({ img: st.img });
    });

    el.trail.addEventListener('click', function (e) {
      var b = e.target.closest('[data-go]');
      if (b) self.goTo(+b.getAttribute('data-go'));
    });
    el.tabs.addEventListener('click', function (e) {
      var b = e.target.closest('[data-opt]');
      if (!b || b.getAttribute('data-opt') === self.state.opt) return;
      self.state.opt = b.getAttribute('data-opt');
      self.build();
    });
    el.swipe.addEventListener('click', function () { self.goTo(self.state.cur + 1); });
    el.prev.addEventListener('click', function () { self.goTo(self.state.cur - 1); });
    el.next.addEventListener('click', function () { self.goTo(self.state.cur + 1); });
    el.airplane.addEventListener('click', function () { if (self.air) self.open({ img: self.air }); });

    /* device picker */
    el.apple.addEventListener('click', function () {
      self.closeMenu();
      if (self.state.phone === 'iphone') return;
      self.state.phone = 'iphone'; self.state.opt = 'tap'; self.state.cur = 0;
      self.build();
    });
    el.android.addEventListener('click', function (e) {
      e.stopPropagation();
      if (self.brands.length > 1) {
        if (el.menu.hidden) self.openMenu(); else self.closeMenu();
        return;
      }
      /* one released brand → plain toggle, no menu */
      if (self.state.phone === 'android') return;
      self.state.phone = 'android';
      self.state.brand = self.brands[0] || 'samsung';
      self.state.opt = 'tap'; self.state.cur = 0;
      self.build();
    });
    el.menu.addEventListener('click', function (e) {
      var b = e.target.closest('[data-hti-brand]');
      if (!b) return;
      self.state.phone = 'android';
      self.state.brand = b.getAttribute('data-hti-brand');
      self.state.brandKnown = true;
      self.state.opt = 'tap'; self.state.cur = 0;
      self.closeMenu();
      self.build();
      el.android.focus();
    });
    document.addEventListener('click', function (e) {
      if (!el.menu.hidden && !el.menu.contains(e.target)) self.closeMenu();
    });

    /* lightbox */
    $$(el.lb, '[data-hti-lb-close]').forEach(function (b) {
      b.addEventListener('click', function () { self.close(); });
    });
    el.lbReplay.addEventListener('click', function () {
      var v = el.lbMedia.querySelector('video');
      if (!v) return;
      try { v.currentTime = 0; } catch (err) {}
      el.lbReplay.hidden = true;
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (!el.lb.hidden) self.close();
      else if (!el.menu.hidden) { self.closeMenu(); el.android.focus(); }
    });

    /* desktop arrow keys on the carousel */
    el.car.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); self.goTo(self.state.cur + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); self.goTo(self.state.cur - 1); }
    });

    /* keep the current slide centred when the width changes */
    var rt = 0;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { self.jump(self.state.cur, false); }, 120);
    });
  };

  Guide.prototype.openMenu = function () {
    this.el.menu.hidden = false;
    this.el.android.setAttribute('aria-expanded', 'true');
    var sel = this.el.menu.querySelector('[aria-selected="true"]') || this.el.menu.querySelector('[data-hti-brand]');
    if (sel) sel.focus();
  };
  Guide.prototype.closeMenu = function () {
    this.el.menu.hidden = true;
    this.el.android.setAttribute('aria-expanded', 'false');
  };

  Guide.prototype.open = function (m) {
    var el = this.el;
    this.lastFocus = document.activeElement;
    el.lbReplay.hidden = true;
    if (m.vid) {
      el.lbMedia.innerHTML = '<video src="' + esc(m.vid) + '"' + (m.poster ? ' poster="' + esc(m.poster) + '"' : '') + ' muted playsinline autoplay aria-hidden="true"></video>';
      var v = el.lbMedia.querySelector('video');
      v.addEventListener('ended', function () { el.lbReplay.hidden = false; });
      var p = v.play(); if (p && p.catch) p.catch(function () { el.lbReplay.hidden = false; });
    } else {
      el.lbMedia.innerHTML = '<img src="' + esc(m.img) + '" alt="">';
    }
    if (el.lb.parentNode !== document.body) document.body.appendChild(el.lb); /* escape theme stacking contexts */
    el.lb.hidden = false;
    document.documentElement.classList.add('hti-lock');
    var x = el.lb.querySelector('.hti-lb__x');
    if (x) x.focus();
  };
  Guide.prototype.close = function () {
    var el = this.el;
    el.lb.hidden = true;
    el.lbMedia.innerHTML = '';
    el.lbReplay.hidden = true;
    document.documentElement.classList.remove('hti-lock');
    if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
  };

  /* ---------- FAQ accordion (works for any number of sections) ---------- */
  function bindFaq(root) {
    $$(root, '[data-hti-q]').forEach(function (q) {
      q.addEventListener('click', function () {
        var a = document.getElementById(q.getAttribute('aria-controls'));
        var open = q.getAttribute('aria-expanded') === 'true';
        q.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (a) a.hidden = open;
      });
    });
  }

  function init() {
    $$(document, '[data-hti]').forEach(function (root) {
      if (root.__hti) return;
      root.__hti = true;
      bindFaq(root);
      var g = new Guide(root);
      root.__htiGuide = g;
    });
  }
  /* theme editor: drop a lightbox that was moved to <body> when its section is removed */
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target && e.target.querySelector && e.target.querySelector('[data-hti]');
    var g = root && root.__htiGuide;
    if (g && g.el && g.el.lb && g.el.lb.parentNode === document.body) {
      document.documentElement.classList.remove('hti-lock');
      document.body.removeChild(g.el.lb);
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  /* theme editor: re-init when the section is re-rendered */
  document.addEventListener('shopify:section:load', init);
})();
